module.exports = __webpack_public_path__ + "static/media/logo2.eeda3b58.svg";